import { WorkHour } from "../../../services/generated/waba-api/models/work-hour";

/**
 * When a dish marked "Épuisé aujourd'hui" comes back by itself: the next time the restaurant opens after `now`,
 * from its work hours (HHMM integers, `days` = ISO week days "1,2,3" with 1 = Monday, empty = every day). A lunch
 * dish sold out at noon comes back at dinner, one sold out at night comes back the next morning.
 * Without any usable work hours: tomorrow at midnight (local time).
 */
export function nextOpening(hours: WorkHour[] | null | undefined, now: Date): Date {
  let best: Date | null = null;
  for (let offset = 0; offset <= 7; offset++) {
    const day = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset);
    const isoDay = day.getDay() === 0 ? 7 : day.getDay();
    for (const block of hours ?? []) {
      const start = block.startWorkHour;
      if (typeof start !== "number" || start < 0 || start >= 2400 || !opensOn(block.days, isoDay)) {
        continue;
      }
      const candidate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), Math.floor(start / 100), start % 100);
      if (candidate > now && (!best || candidate < best)) {
        best = candidate;
      }
    }
    if (best) {
      return best;
    }
  }
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
}

function opensOn(days: string | null | undefined, isoDay: number): boolean {
  const list = (days ?? "")
    .split(",")
    .map((value) => Number(value.trim()))
    .filter((value) => value >= 1 && value <= 7);
  return !list.length || list.includes(isoDay);
}
